/**
 * The file enables `index.js` to import all vue routes
 * in a one-shot manner. There should not be any reason to edit this file.
 */

const files = require.context('.', true, /\.js$/);
const routes = [];

files.keys().forEach((key) => {
  if (key === './index.js' || key === './__all.js') return;
  routes.push(files(key).default);
});

export default routes;
